exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3DATHbOIV7TGg8XqA95PYN{color:\"[theme:themePrimary, default:#0078D4]\"}html[dir=ltr] ._3DATHbOIV7TGg8XqA95PYN{margin-left:0}html[dir=rtl] ._3DATHbOIV7TGg8XqA95PYN{margin-right:0}html[dir] ._25zy7Y5Xmb9KnIU2bQlNgS:hover{background:transparent}.pq1cQSOyKMgIpNlQh-8tg{width:0}", ""]);

// exports
exports.locals = {
	"moreLabel": "_3DATHbOIV7TGg8XqA95PYN",
	"moreRoot": "_25zy7Y5Xmb9KnIU2bQlNgS",
	"noIcon": "pq1cQSOyKMgIpNlQh-8tg"
};